// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-modal-resume{
  width: 100%;
  max-width: 480px;
  height: auto;
  max-height: 100%;
  overflow: auto;
  cursor: default;
  transform: translate(-50%, -50%);
  transition: opacity 0.5s, visibility 0.5s;
  margin: 0;
}

.resume-modal-header {
  position: relative;
  background-color: var(--secondary-font);
  border-radius: 20px 0px 0px 0px;
  width: 100%;
  height: 72px;
  margin: auto;
}

.resume-modal-header p {
  text-align: center;
  color: #fff;
  bottom: 0;
  padding-top: 33px;
  font-weight: bold;
  font-size: 20px;
}

.resume-modal-header button {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 8px;
  top: 4px;
}

.resume-modal{
  height: 100%;
  background-color: var(--screen-background);
  border-radius: 24px 0 0 0;
}

.resumo{
  max-width: 600px;
  margin: auto;

}

.line-separator{
  height: 1px;
  background-color: #CCCCCC;
  width: 95%;
  margin: 0 auto;
}

.container-details{
  padding: 5px 10px;
}

.line-detail{
  display: grid;
  grid-template-columns: 0.3fr 0.7fr;
  -moz-column-gap: 20px;
       column-gap: 20px;
  font-size: 12px;
  color: var(--filter);
  font-weight: 400;
}

.question-detail p,
.answer-detail p{
    margin: 0.5rem 0 0.5rem 0;
    color: var(--filter);
}

.filtros{
  max-width: 95%;
  margin: auto;
  margin-top: 10px;
  border-top: 1px solid #cccccc;
}

.super-poder{
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  margin-top: 10px;
  color: var(--filter);
}

.super-poder p{
  margin-top: 5px;
  color: var(--filter);
}

.mr-super-poder-icon{
  transform: scale(0.8);
}

.mr-box-title-icon h3 {
    font-size: 20px;
    font-weight: 700;
}

.mr-box-subtitle {
    color: var(--text);
}

.mr-prod-text p {
    color: var(--text);
}

.mr-box-lista-valores {
    color: var(--text);
}

.resumo-container {
    display: grid;
    grid-template-columns: 0.3fr 0.7fr;
    row-gap: 10px;
    -moz-column-gap: 20px;
         column-gap: 20px;
    justify-content: center;
    align-items: center;
    padding: 20px 10px;
    color: var(--text);
}

.resumo-container * {
    margin: 0;
}

.resumo-container > p {
    font-size: 12px;
}

.resumo-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
}

.intervention-index{
  color: var(--primary-font);
}

.resumo-list-name {
    font-size: 16px;
    font-weight: 700;
}

.resumo-updated {
    font-size: 10px;
}

.resumo-image,
.resumo-property-key {
    grid-template-columns: 1 / 2;
}

.resumo-title,
.resumo-property-value {
    grid-template-columns: 2 / 3;
}

.resumo-image > img {
    max-width: 100%;
    border-radius: 8px;
}

.resumo-property-key::first-letter {
    text-transform: uppercase;
}

.resumo-property-value {
    text-transform: lowercase;
    font-weight: 700;
}

.gray-text {
    color: var(--text);
}

.list-save-modal {
    margin: 0 16px;
    height: 100%;
    transition: visibility .5s;
}

.list-save-modal #content {
    background-color: #e8e8e8;
    padding: 0 20px 32px 16px;
}

#content label p {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
}

#content input {
    border-radius: 8px;
    border: 1px solid #5D5757;
    color: #000;
}

.list-save-modal-header {
    position: relative;
    background-color: var(--primary-font);
    border-radius: 20px 0px 0px 0px;
    width: 100%;
    height: 72px;
}

.list-save-modal-header p {
    text-align: center;
    color: #fff;
    bottom: 0;
    padding-top: 33px;
    font-weight: bold;
    font-size: 20px;
}

.list-save-modal-header button {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 8px;
    top: 4px;
}

.save-list-button {
    display: flex;
    justify-content: flex-end;
    margin: 0;
}

.save-list-button div {
    width: 160px;
    height: 40px;
}

.button-trocar{
    color: var(--text) !important;
    text-decoration: underline !important;
    cursor: pointer;
}

.button-disabled {
    background-color: var(--primary-button-disabled);
    color: #fff;
}

.boxSALVALISTA {
    justify-content: center;
}

.botao{
    cursor: pointer;
}

.spinner-container {
    display: grid;
    justify-content: center;
}

@media (min-width: 768px) {
    .list-save-modal {
        margin: 0;
    }

    .list-save-modal #content {
        height: 100%;
    }

    .mr-box-save-lista {
        top: 0;
    }

    .save-list-button {
        position: fixed;
        bottom: 0;
        right: 0;
        margin: 0 20px 32px 0;
    }

}

@media screen and (min-width: 768px) {
    .resumo-container {
        grid-template-columns: 1fr 0.3fr 0.7fr;
        grid-template-rows: auto auto;
        row-gap: 0;
    }

    .resumo-image {
        grid-column: 1 / 2;
        grid-row: 1 / 6;
    }

    .resumo-property-key {
        grid-column: 2 / 3;
    }

    .resumo-property-value {
        grid-column: 3 / 4;
    }

    .resumo-title {
        grid-column: 2 / 4;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/resumo-lista/resumo-lista.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,yCAAyC;EACzC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,qBAAgB;OAAhB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,aAAa;IACb,qBAAgB;SAAhB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,+BAA+B;IAC/B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,gDAAgD;IAChD,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,MAAM;IACV;;IAEA;QACI,eAAe;QACf,SAAS;QACT,QAAQ;QACR,qBAAqB;IACzB;;AAEJ;;AAEA;IACI;QACI,sCAAsC;QACtC,6BAA6B;QAC7B,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".box-modal-resume{\n  width: 100%;\n  max-width: 480px;\n  height: auto;\n  max-height: 100%;\n  overflow: auto;\n  cursor: default;\n  transform: translate(-50%, -50%);\n  transition: opacity 0.5s, visibility 0.5s;\n  margin: 0;\n}\n\n.resume-modal-header {\n  position: relative;\n  background-color: var(--secondary-font);\n  border-radius: 20px 0px 0px 0px;\n  width: 100%;\n  height: 72px;\n  margin: auto;\n}\n\n.resume-modal-header p {\n  text-align: center;\n  color: #fff;\n  bottom: 0;\n  padding-top: 33px;\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.resume-modal-header button {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  right: 8px;\n  top: 4px;\n}\n\n.resume-modal{\n  height: 100%;\n  background-color: var(--screen-background);\n  border-radius: 24px 0 0 0;\n}\n\n.resumo{\n  max-width: 600px;\n  margin: auto;\n\n}\n\n.line-separator{\n  height: 1px;\n  background-color: #CCCCCC;\n  width: 95%;\n  margin: 0 auto;\n}\n\n.container-details{\n  padding: 5px 10px;\n}\n\n.line-detail{\n  display: grid;\n  grid-template-columns: 0.3fr 0.7fr;\n  column-gap: 20px;\n  font-size: 12px;\n  color: var(--filter);\n  font-weight: 400;\n}\n\n.question-detail p,\n.answer-detail p{\n    margin: 0.5rem 0 0.5rem 0;\n    color: var(--filter);\n}\n\n.filtros{\n  max-width: 95%;\n  margin: auto;\n  margin-top: 10px;\n  border-top: 1px solid #cccccc;\n}\n\n.super-poder{\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.06px;\n  margin-top: 10px;\n  color: var(--filter);\n}\n\n.super-poder p{\n  margin-top: 5px;\n  color: var(--filter);\n}\n\n.mr-super-poder-icon{\n  transform: scale(0.8);\n}\n\n.mr-box-title-icon h3 {\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.mr-box-subtitle {\n    color: var(--text);\n}\n\n.mr-prod-text p {\n    color: var(--text);\n}\n\n.mr-box-lista-valores {\n    color: var(--text);\n}\n\n.resumo-container {\n    display: grid;\n    grid-template-columns: 0.3fr 0.7fr;\n    row-gap: 10px;\n    column-gap: 20px;\n    justify-content: center;\n    align-items: center;\n    padding: 20px 10px;\n    color: var(--text);\n}\n\n.resumo-container * {\n    margin: 0;\n}\n\n.resumo-container > p {\n    font-size: 12px;\n}\n\n.resumo-title {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 10px;\n}\n\n.intervention-index{\n  color: var(--primary-font);\n}\n\n.resumo-list-name {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.resumo-updated {\n    font-size: 10px;\n}\n\n.resumo-image,\n.resumo-property-key {\n    grid-template-columns: 1 / 2;\n}\n\n.resumo-title,\n.resumo-property-value {\n    grid-template-columns: 2 / 3;\n}\n\n.resumo-image > img {\n    max-width: 100%;\n    border-radius: 8px;\n}\n\n.resumo-property-key::first-letter {\n    text-transform: uppercase;\n}\n\n.resumo-property-value {\n    text-transform: lowercase;\n    font-weight: 700;\n}\n\n.gray-text {\n    color: var(--text);\n}\n\n.list-save-modal {\n    margin: 0 16px;\n    height: 100%;\n    transition: visibility .5s;\n}\n\n.list-save-modal #content {\n    background-color: #e8e8e8;\n    padding: 0 20px 32px 16px;\n}\n\n#content label p {\n    font-size: 16px;\n    font-weight: bold;\n    margin: 0;\n}\n\n#content input {\n    border-radius: 8px;\n    border: 1px solid #5D5757;\n    color: #000;\n}\n\n.list-save-modal-header {\n    position: relative;\n    background-color: var(--primary-font);\n    border-radius: 20px 0px 0px 0px;\n    width: 100%;\n    height: 72px;\n}\n\n.list-save-modal-header p {\n    text-align: center;\n    color: #fff;\n    bottom: 0;\n    padding-top: 33px;\n    font-weight: bold;\n    font-size: 20px;\n}\n\n.list-save-modal-header button {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    right: 8px;\n    top: 4px;\n}\n\n.save-list-button {\n    display: flex;\n    justify-content: flex-end;\n    margin: 0;\n}\n\n.save-list-button div {\n    width: 160px;\n    height: 40px;\n}\n\n.button-trocar{\n    color: var(--text) !important;\n    text-decoration: underline !important;\n    cursor: pointer;\n}\n\n.button-disabled {\n    background-color: var(--primary-button-disabled);\n    color: #fff;\n}\n\n.boxSALVALISTA {\n    justify-content: center;\n}\n\n.botao{\n    cursor: pointer;\n}\n\n.spinner-container {\n    display: grid;\n    justify-content: center;\n}\n\n@media (min-width: 768px) {\n    .list-save-modal {\n        margin: 0;\n    }\n\n    .list-save-modal #content {\n        height: 100%;\n    }\n\n    .mr-box-save-lista {\n        top: 0;\n    }\n\n    .save-list-button {\n        position: fixed;\n        bottom: 0;\n        right: 0;\n        margin: 0 20px 32px 0;\n    }\n\n}\n\n@media screen and (min-width: 768px) {\n    .resumo-container {\n        grid-template-columns: 1fr 0.3fr 0.7fr;\n        grid-template-rows: auto auto;\n        row-gap: 0;\n    }\n\n    .resumo-image {\n        grid-column: 1 / 2;\n        grid-row: 1 / 6;\n    }\n\n    .resumo-property-key {\n        grid-column: 2 / 3;\n    }\n\n    .resumo-property-value {\n        grid-column: 3 / 4;\n    }\n\n    .resumo-title {\n        grid-column: 2 / 4;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
